import CustomText from "../atomic/CustomText";
import DetailRenderer from "../global/forms/DetailRenderer";

const GuarantorInfo = ({ order }: any) => {
  const { guarantorName } = order || {};
  return (
    <div id="guarantor info">
      <CustomText
        text={'Guarantor Information'}
        fontWeight="font-medium"
        className="reviewCardHeading my-5"
      />


      <div className="reviewCard">
        {order?.testType?.test !== 5 && order?.testType?.test !== 8 && (
          <DetailRenderer
            data={{ guarantorName }}
            groupFields={[]}
            hiddenFields={[]}
            MainHeading="Guarantor Information"
            approval={true}
            approvalSectionUrl={`${`/access/online-order/${order.supportingSection.id}#Guarantor%20Information`}`}
          />
        )}
      </div>
    </div>
  );
};

export default GuarantorInfo;